import { ButtonHTMLAttributes, forwardRef } from 'react'

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary'
  size?: 'sm' | 'md' | 'lg'
}

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(
  ({ variant = 'primary', size = 'md', className = '', children, type = 'button', ...props }, ref) => {
    const baseClasses =
      'px-3 py-2.5 text-sm font-medium rounded-lg border transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-background disabled:opacity-55 disabled:cursor-not-allowed'

    const variantClasses: Record<NonNullable<ButtonProps['variant']>, string> = {
      primary:
        'bg-background-elevated text-text border-border-muted hover:bg-background-card active:scale-[0.985]',
      secondary:
        'bg-background-card text-text-muted border-border hover:bg-background-elevated active:scale-[0.985]',
    }

    const sizeClasses: Record<NonNullable<ButtonProps['size']>, string> = {
      sm: 'px-2.5 py-2 text-xs',
      md: 'px-3 py-2.5 text-sm',
      lg: 'px-4 py-3 text-base',
    }

    return (
      <button
        ref={ref}
        type={type}
        className={`${baseClasses} ${variantClasses[variant]} ${sizeClasses[size]} ${className}`}
        aria-label={props['aria-label'] || (typeof children === 'string' ? children : undefined)}
        {...props}
      >
        {children}
      </button>
    )
  }
)

Button.displayName = 'Button'
